import { KpkFilterType } from "@keepeek/commons";
import { KSplitValue } from "@keepeek/refront-components";
import { atomFamily } from "recoil";

export const kSplitValueAtom = atomFamily<KSplitValue, string>({
  key: "kSplitValueAtom",
  default: { id: "text", label: "search.input.split.item.text.label", type: KpkFilterType.Text },
});
